import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  caseStudiesState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    items: [],
    errorMessage: '',
  },
  caseStudyState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const caseStudiesSlice = createSlice({
  name: 'caseStudies',
  initialState: initialState,
  reducers: {
    getCaseStudiesRequest: (state: any) => {
      state.caseStudiesState.isFetching = true
      state.caseStudiesState.isFetched = false
      state.caseStudiesState.isFailed = false
      state.caseStudiesState.errorMessage = ''
    },
    getCaseStudiesSuccess: (state: any, action) => {
      state.caseStudiesState.isFetching = false
      state.caseStudiesState.isFetched = true
      state.caseStudiesState.items = action.payload.items
    },
    getCaseStudiesFailure: (state: any, action) => {
      state.caseStudiesState.isFetching = false
      state.caseStudiesState.isFetched = true
      state.caseStudiesState.isFailed = true
      state.caseStudiesState.errorMessage = action.payload.errorMessage
    },
    getCaseStudyRequest: (state: any) => {
      state.caseStudyState.isFetching = true
      state.caseStudyState.isFetched = false
      state.caseStudyState.isFailed = false
      state.caseStudyState.errorMessage = ''
    },
    getCaseStudySuccess: (state: any, action) => {
      state.caseStudyState.isFetching = false
      state.caseStudyState.isFetched = true
      state.caseStudyState.item = action.payload.item
    },
    getCaseStudyFailure: (state: any, action) => {
      state.caseStudyState.isFetching = false
      state.caseStudyState.isFetched = true
      state.caseStudyState.isFailed = true
      state.caseStudyState.errorMessage = action.payload.errorMessage
    },
  },
})

export const {
  getCaseStudiesRequest,
  getCaseStudiesSuccess,
  getCaseStudiesFailure,
  getCaseStudyRequest,
  getCaseStudySuccess,
  getCaseStudyFailure,
} = caseStudiesSlice.actions

export default caseStudiesSlice.reducer
